import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { DateFormateService } from 'src/app/services/date-formate.service';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { AlertService } from 'src/app/shared/providers/AlertProvider';
import { ExportExcelService } from 'src/app/shared/xlsx-view/export-excel.service';
import { MONTH, REPORT_MESSAGE } from '../../shared/models/mock-data';
import { RegionModel } from '../../shared/models/region';
import { StateModel } from '../../shared/models/state';
import { CampaignProvider } from '../../shared/providers/campaign.provider';
import { ChannelProvider } from '../../shared/providers/channel.provider';
import { AdminDataProvider } from '../../shared/providers/master-provider/admin-data.provider';
import { RegionProvider } from '../../shared/providers/region.provider';
import { RolesProvider } from '../../shared/providers/roles.provider';
import { StateProvider } from '../../shared/providers/state.provider';

@Component({
  selector: 'app-leader-report',
  templateUrl: './leader-report.component.html',
  styleUrls: ['./leader-report.component.scss']
})
export class LeaderReportComponent implements OnInit {


  searchText: string;
  data: any[];

  constructor() { }

  ngOnInit() {

    this.data = [
      {
        "Link": "https://api1.bud4trade.bigcityexperiences.com/uploads/otherreports/Leaderboard_Final_Jan21.xlsx",
        "State": "Consolidated Report",
        "Year": "January 2021"
      },
      {
        "Link": "https://api1.bud4trade.bigcityexperiences.com/uploads/otherreports/Leaderboard_Final_Feb21.xlsx",
        "State": "Karnataka",
        "Year": "Ferbruary 2021"
      },
      {
        "Link": "https://api1.bud4trade.bigcityexperiences.com/uploads/otherreports/Leaderboard_Final_Mar21.xlsx",
        "State": "Karnataka",
        "Year": "March 2021"
      },
    ];

  }

}
